(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.querySelector('.testimonials-wrapper');
  const cards = document.querySelectorAll('.testimonial-card');
  const prevBtn = document.querySelector('.arrow-btn.prev');
  const nextBtn = document.querySelector('.arrow-btn.next');
  
  if (!wrapper || cards.length <= 3) return;

  let index = 0;
  const visibleCount = 3;
  const total = cards.length;

  function updateSlider() {
    const offset = -(index * (cards[0].offsetWidth + 24));
    wrapper.style.transform = `translateX(${offset}px)`;
  }

  nextBtn.addEventListener('click', () => {
    index = (index + 1) % (total - visibleCount + 1);
    updateSlider();
  });

  prevBtn.addEventListener('click', () => {
    index = (index - 1 + (total - visibleCount + 1)) % (total - visibleCount + 1);
    updateSlider();
  });

  // Auto-scroll every 4 seconds
  setInterval(() => {
    nextBtn.click();
  }, 4000);
});

  } catch(e) { console.error(e); }
})();
})();
